import React from 'react';

import card1Image from './images/card1.png';
import card2Image from './images/card2.png';
import card3Image from './images/card3.png';
import card4Image from './images/card4.png';
import card5Image from './images/card5.png';
import card6Image from './images/card6.png';
import card7Image from './images/card7.png';
import arrowIcon from './images/arrow_icon.png';
import arrowLightIcon from './images/arrow_light_icon.png';
import createJobIcon from './images/create_job_icon.png'
import reviewIcon from './images/review_icon.png'
import trackIcon from './images/track_icon.png'
import feedbackIcon from './images/feedbback_icon.png'
import expertsIcon from './images/experts_icon.png'
import acceptIcon from './images/accept_icon.png'
import signUpIcon from './images/signup_icon.png'
import callIcon from './images/call_icon.png'

import css from './SectionWhyGigExecs.module.css';
import { FormattedMessage } from 'react-intl';


const SectionWhyGigExecs = props => {

    return (
        <div className={css.root}>

            <p className={css.subtitle}>
                <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.subtitle" />
            </p>
            <p className={css.title}>
                <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.title" />
            </p>

            <div className={css.horizontalWrapper}>
                <div className={css.cardWrapper}>
                    <img className={css.cardImage} src={card1Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card1.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card1.info" />
                    </p>

                    <div className={css.cardBottomWrapper}>
                        <p className={css.cardDate}>
                            <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card1.date" />
                        </p>

                        <div className={css.readMoreWrapper}>
                            <p className={css.readMore}>
                                <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.readMore" />
                            </p>
                            <img className={css.arrow} src={arrowIcon} />
                        </div>
                    </div>

                </div>

                <div className={css.cardWrapper}>
                    <img className={css.cardImage} src={card2Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card2.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card2.info" />
                    </p>

                    <div className={css.cardBottomWrapper}>
                        <p className={css.cardDate}>
                            <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card2.date" />
                        </p>

                        <div className={css.readMoreWrapper}>
                            <p className={css.readMore}>
                                <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.readMore" />
                            </p>
                            <img className={css.arrow} src={arrowIcon} />
                        </div>
                    </div>
                </div>

                <div className={css.cardWrapper}>
                    <img className={css.cardImage} src={card3Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card3.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card3.info" />
                    </p>

                    <div className={css.cardBottomWrapper}>
                        <p className={css.cardDate}>
                            <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card3.date" />
                        </p>

                        <div className={css.readMoreWrapper}>
                            <p className={css.readMore}>
                                <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.readMore" />
                            </p>
                            <img className={css.arrow} src={arrowIcon} />
                        </div>
                    </div>
                </div>

            </div>

            <div className={css.goToBlogWrapper}>
                <p className={css.goToBlog}>
                    <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.goToBlog" />
                </p>
                <img className={css.arrow} src={arrowLightIcon} />
            </div>

            <p className={css.title2}>
                <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.title2" />
            </p>

            <div className={css.panelWrapper}>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={signUpIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step1.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step1.info" />
                    </p>
                </div>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={createJobIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step2.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step2.info" />
                    </p>
                </div>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={reviewIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step3.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step3.info" />
                    </p>
                </div>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={expertsIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step4.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step4.info" />
                    </p>
                </div>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={acceptIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step5.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step5.info" />
                    </p>
                </div>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={callIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step6.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step6.info" />
                    </p>
                </div>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={trackIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step7.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step7.info" />
                    </p>
                </div>

                <div className={css.panelItem}>
                    <img className={css.panelItemIcon} src={feedbackIcon} />
                    <p className={css.panelItemTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step8.title" />
                    </p>
                    <p className={css.panelItemInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.step8.info" />
                    </p>
                </div>
            </div>


            <p className={css.title2}>
                <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.title3" />
            </p>
            <div className={css.horizontalWrapperWrapAt50}>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card4Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card4.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card4.info" />
                    </p>
                </div>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card5Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card5.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card5.info" />
                    </p>
                </div>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card6Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card6.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card6.info" />
                    </p>
                </div>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card7Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card7.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingClientsPage.SectionWhyGigExecs.card7.info" />
                    </p>
                </div>

            </div>
        </div>

    );
};

export default SectionWhyGigExecs;
